import script from "./OGrupoAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./OGrupoAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./OGrupoAvatar.vue?vue&type=style&index=0&id=6c260bd8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c260bd8"]])

export default __exports__